import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface SelectedPlantState {
  plantId: string | null;
  setPlantId: (id: string | null) => void;
  clear: () => void;
}

/**
 * 사용자가 현재 보고 있는 발전소.
 *
 * 거의 모든 monitoring 페이지가 (plantId, timeRange) 쌍을 키로 잡으므로
 * cross-page 세션 컨텍스트로 shared/stores 에 둔다. entity는 도메인 모델만.
 * 마지막 선택은 persist — 재방문 시 같은 발전소로 복구되는 게 자연스럽다.
 */
export const useSelectedPlantStore = create<SelectedPlantState>()(
  persist(
    (set) => ({
      plantId: null,
      setPlantId: (plantId) => set({ plantId }),
      clear: () => set({ plantId: null }),
    }),
    {
      name: 'heviton.session.selected-plant',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
